var _path, _path2, _path3, _g, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0803 18.5928H3.7793C3.3653 18.5928 3.0293 18.2568 3.0293 17.8428C3.0293 17.4288 3.3653 17.0928 3.7793 17.0928H10.0803C10.4943 17.0928 10.8303 17.4288 10.8303 17.8428C10.8303 18.2568 10.4943 18.5928 10.0803 18.5928Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1911 8.90039H12.8911C12.4771 8.90039 12.1411 8.56439 12.1411 8.15039C12.1411 7.73639 12.4771 7.40039 12.8911 7.40039H19.1911C19.6051 7.40039 19.9411 7.73639 19.9411 8.15039C19.9411 8.56439 19.6051 8.90039 19.1911 8.90039Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_67_1651",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 5,
    width: 7,
    height: 7
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5.00049H9.2258V11.1921H3V5.00049Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_67_1651)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.113 6.5C5.224 6.5 4.5 7.216 4.5 8.097C4.5 8.977 5.224 9.692 6.113 9.692C7.003 9.692 7.726 8.977 7.726 8.097C7.726 7.216 7.003 6.5 6.113 6.5ZM6.113 11.192C4.397 11.192 3 9.804 3 8.097C3 6.39 4.397 5 6.113 5C7.83 5 9.226 6.39 9.226 8.097C9.226 9.804 7.83 11.192 6.113 11.192Z",
    fill: "black"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3879 16.208C16.4979 16.208 15.7739 16.924 15.7739 17.804C15.7739 18.685 16.4979 19.4 17.3879 19.4C18.2769 19.4 18.9999 18.685 18.9999 17.804C18.9999 16.924 18.2769 16.208 17.3879 16.208ZM17.3879 20.9C15.6709 20.9 14.2739 19.511 14.2739 17.804C14.2739 16.097 15.6709 14.708 17.3879 14.708C19.1039 14.708 20.4999 16.097 20.4999 17.804C20.4999 19.511 19.1039 20.9 17.3879 20.9Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.e6e6ead4572f2199201d9d13a59b8a85.svg";
export { ForwardRef as ReactComponent };